export enum AnnouncementChannel {
  SYSTEM = 'SYSTEM',
  EMAIL = 'EMAIL',
  SYSTEM_I_EMAIL = 'SYSTEM_I_EMAIL',
}

export const ANNOUNCEMENT_CHANNEL_LABELS: Record<AnnouncementChannel, string> =
  {
    [AnnouncementChannel.SYSTEM]: 'Tylko w systemie',
    [AnnouncementChannel.EMAIL]: 'Tylko mailowo',
    [AnnouncementChannel.SYSTEM_I_EMAIL]: 'W systemie oraz mailowo',
  };
